import React from "react";
import "../../styles/homeCategories.css";

/**
 * Presentational component displaying shimmer placeholders during categories loading.
 */
const HomeCategoriesSkeleton = () => {
  // Render 8 placeholder cards to fit nicely on desktop grids
  const skeletonArray = Array.from({ length: 8 });

  return (
    <div className="categories-container" aria-hidden="true">
      {skeletonArray.map((_, idx) => (
        <div key={idx} className="category-skeleton-card">
          <div className="category-skeleton-circle skeleton-shimmer" />
          <div className="category-skeleton-text skeleton-shimmer" />
        </div>
      ))}
    </div>
  );
};

export default HomeCategoriesSkeleton;
